var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeRank4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bronze_rank_4_svg__clip0_1947_6941)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bronze_rank_4_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 200
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.335H0v199.189h200.865V.335z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bronze_rank_4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.334 38.824c-5.344-5.636-14.62-4.171-18.037 2.811-8.93 18.23-6.153 40.877 8.615 56.453 18.43 19.435 48.732 20.688 68.68 3.224L37.333 38.824z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 76.353C6.903 74.1-.439 79.97.024 87.735c1.201 20.283 14.761 38.594 35.265 44.818 25.585 7.765 52.553-6.165 61.308-31.241l-82.275-24.96z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 122.747c-7.507 1.936-10.76 10.777-6.358 17.177 11.497 16.723 32.546 25.335 53.291 19.994 25.89-6.665 41.771-32.606 36.315-58.606l-42.55 10.953-40.704 10.476.006.006z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.824c5.344-5.636 14.621-4.171 18.037 2.811 8.931 18.23 6.153 40.877-8.614 56.453-18.43 19.435-48.732 20.688-68.68 3.224l59.257-62.488z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 76.353c7.419-2.253 14.762 3.618 14.305 11.388-1.202 20.282-14.762 38.594-35.266 44.818-25.585 7.764-52.553-6.165-61.308-31.241l82.269-24.965z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 122.747c7.507 1.936 10.759 10.777 6.358 17.177-11.497 16.723-32.547 25.335-53.291 19.994-25.89-6.665-41.77-32.606-36.315-58.606l42.55 10.953 40.704 10.476-.006.006z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.335h108.224c6.47 0 11.72 5.271 11.72 11.765v121.335c0 36.471-29.499 66.083-65.832 66.083-36.332 0-65.832-29.612-65.832-66.083V12.1c0-6.494 5.25-11.765 11.72-11.765z",
    fill: "#CE7C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 68.165h75.413c4.506 0 8.169 3.67 8.169 8.2v49.594c0 25.418-20.557 46.047-45.873 46.047-25.321 0-45.872-20.635-45.872-46.047V76.365c0-4.523 3.657-8.2 8.169-8.2h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 70.518c3.211 0 5.825 2.623 5.825 5.847v49.594c0 24.094-19.526 43.694-43.529 43.694-24.002 0-43.528-19.6-43.528-43.694V76.365c0-3.224 2.613-5.847 5.825-5.847h75.413m0-2.353h-75.42c-4.511 0-8.168 3.67-8.168 8.2v49.594c0 25.43 20.54 46.047 45.872 46.047 25.333 0 45.873-20.617 45.873-46.047V76.365c0-4.53-3.657-8.2-8.169-8.2h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.335h-44.982L35.072 75.583v51.841l125.3-125.783a11.626 11.626 0 00-5.356-1.306zM95.712 113.1l71.024-71.294V12.43L81.079 98.412 95.712 113.1z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.223 23.571l2.033 6.282a1.678 1.678 0 001.6 1.165h6.581c1.629 0 2.303 2.088.984 3.047l-5.321 3.882a1.692 1.692 0 00-.609 1.883l2.033 6.282c.504 1.553-1.265 2.847-2.584 1.883l-5.321-3.883a1.674 1.674 0 00-1.975 0l-5.32 3.883c-1.319.958-3.089-.33-2.585-1.883l2.034-6.282a1.693 1.693 0 00-.61-1.883l-5.32-3.882c-1.32-.959-.64-3.047.984-3.047h6.58c.727 0 1.372-.47 1.6-1.165l2.034-6.282c.504-1.553 2.69-1.553 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 23.571l2.033 6.282a1.678 1.678 0 001.6 1.165h6.581c1.629 0 2.303 2.088.984 3.047l-5.32 3.882a1.691 1.691 0 00-.61 1.883l2.033 6.282c.504 1.553-1.265 2.847-2.584 1.883l-5.321-3.883a1.674 1.674 0 00-1.975 0l-5.32 3.883c-1.319.958-3.089-.33-2.585-1.883l2.034-6.282a1.693 1.693 0 00-.61-1.883l-5.32-3.882c-1.32-.959-.64-3.047.984-3.047h6.58c.727 0 1.372-.47 1.6-1.165l2.034-6.282c.504-1.553 2.69-1.553 3.194 0h-.012z",
    fill: "#FEE066"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bronze_rank_4_svg__clip0_1947_6941"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v200H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeRank4);
export default ForwardRef;